export const SET_FEEDBACKS = 'setFeedbacks'
export const SET_FEEDBACK_FILTERS = 'setFeedbackFilters'
export const SET_FEEDBACK = 'setFeedback'
export const SET_FEEDBACK_ERRORS = 'setFeedbackErrors'
export const SET_FEEDBACK_FIELD = 'setFeedbackField'
export const SET_FEEDBACK_STATUSES = 'setFeedbackStatuses'
export const SET_FEEDBACK_BOOKING = 'setFeedbackBooking'
export const SET_FEEDBACK_MANAGERS = 'setFeedbackManagers'
export const SET_FEEDBACK_ORDERS = 'setFeedbackOrders'

export const SET_ORDER_BY_HASH = 'setOrderByHash'

export const APPEND_SUBFEEDBACK = 'appendSubfeedback'
export const REPLACE_SUBFEEDBACK = 'replaceSubfeedback'
export const SET_SUBFEEDBACK_FIELD = 'setSubfeedbackField'

export const SET_BOOKING_SOURCE = 'setBookingSource'
export const SET_BOOKING_SOURCES = 'setBookingSources'
export const SET_BOOKING_SOURCE_FILTERS = 'setBookingSourceFilters'

export const SET_VOUCHERS_LIST = 'setVouchersList'
